module.exports = __webpack_public_path__ + "static/media/citibike_logo.1faabffb.png";